<template>
  <div class="box4">
    <div class="tit">从技术白领进阶技术金领<br/>Java架构师是明智抉择</div>
    <div class="content">
      <div class="left">
        <div class="title">Java架构师</div>
        <p>
          技术权威
          <br />强大的技术实力 <br />优秀的项目管理能力
        </p>
        <p>
          薪资翻倍
          <br />大厂随意挑 <br />快速晋升
        </p>
        <p>
          团队灵魂人物
          <br />项目开发领导权 <br />话语权
        </p>
        <p>
          通往CTO
          <br />开启职场晋升之路
        </p>
      </div>
      <div class="vs">
        <img src="../../assets/architect/box4/vs.png" alt />
      </div>
      <div class="right">
        <div class="title">Java工程师</div>
        <p>
          多年码农经验
          <br />一直做基础技术 <br />重复重复再重复
        </p>
        <p style="margin-bottom: 0.92rem">
          龟速涨薪
          <br />跳槽晋升无门
        </p>
        <p style="margin-bottom: 0.92rem">
          徘徊在技术基层
          <br />无法胜任技术管理岗
        </p>
        <p>
          技术不精进
          <br />无法突破职业瓶颈
        </p>
      </div>
    </div>
    <div class="btn" @click="childMethod">免费领取学习路线图</div>
  </div>
</template>

<script>
import pageTitle from "../../components/common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    }
  },
};
</script>

<style lang="less" scoped>
.box4 {
  padding-bottom: 88px;
  width: 100%;
  background: linear-gradient(180deg, #ebf3ff 0%, #fdfeff 100%);
  .btn{
    width: 400px;
    height: 78px;
    font-size: 34px;
    color: #fff;
    text-align: center;
    line-height: 78px;
    border-radius: 14px;
    background: #ff5627;
    margin: 50px auto 0;
  }
  .tit {
    font-family: PingFangSC-Semibold;
    font-size: 34px;
    text-align: center;
    font-weight: bold;
    letter-spacing: 0px;
    color: #24375c;
  }

  .content {
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    padding-top: 50px;
    background: linear-gradient(180deg, #e0edff 0%, #fdfeff 100%);

    .vs {
      position: absolute;
      top: 130px;
      img {
        width: 80px;
        height: 80px;
      }
    }

    .left {
      margin-right: 20px;
      padding-top: 43px;
      padding-left: 32px;
      width: 325px;
      height: 651px;
      background: url("../../assets/architect/box4/left.png")
        no-repeat;
      background-size: cover;
      border-radius: 20px;
      box-sizing: border-box;

      text-shadow: 2px 3px 40px rgba(0, 0, 0, 0.5);
      .title {
        position: relative;
        margin-bottom: 60px;
        font-family: PingFangSC-Semibold;
        font-size: 32px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0px;
        color: #ffffff;
        &::after {
          position: absolute;
          bottom: -21px;
          left: 0px;
          content: "";
          width: 31px;
          height: 3px;
          background-color: #00ccff;
          border-radius: 2px;
        }
      }
      p {
        margin-bottom: 36px;
        font-family: PingFang SC;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 34px;
        letter-spacing: 0px;
        color: #ffffff;
      }
    }

    .right {
      margin-left: 20px;
      padding-top: 43px;
      padding-right: 32px;
      width: 325px;
      height: 651px;
      text-align: right;
      background: url("../../assets/architect/box4/right.png")
        no-repeat;
      background-size: cover;
      box-shadow: 0px 6px 24px 0px #dbefff;
      border-radius: 20px;
      box-sizing: border-box;

      .title {
        position: relative;
        margin-bottom: 60px;
        font-family: PingFangSC-Medium;
        font-size: 32px;
        font-weight: bold;
        line-height: 36px;
        letter-spacing: 0px;
        color: #24375c;
        &::after {
          position: absolute;
          right: 0px;
          bottom: -21px;
          content: "";
          width: 32px;
          height: 3px;
          background-color: #0074ff;
          border-radius: 2px;
        }
      }
      p {
        margin-bottom: 36px;
        font-family: PingFang SC;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 34px;
        letter-spacing: 0px;
        color: #24375c;
      }
    }
  }
}
</style>
